import React from 'react';
import { motion } from 'framer-motion';

const Watermark = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 0.3 }}
      transition={{ duration: 1, repeat: Infinity, repeatType: "reverse" }}
      className="fixed bottom-4 right-4 opacity-30 text-xs text-green-400 pointer-events-none z-10 font-mono"
    >
      AVO Experimental Network - Unexpected Results Detected
    </motion.div>
  );
};

export default Watermark;